import React from 'react';
import './Top.css';
import previewImage from './assets/rust no recoil script preview.png';
import { FaShoppingCart, FaDiscord } from 'react-icons/fa';
import { Trans, useTranslation } from 'react-i18next';

const Top = () => {
  const { t } = useTranslation();
  return (
    <div className="top-component">
      <div className="top-left">
        <h1>
          <Trans
            i18nKey="top_title"
            components={{ br: <br /> }}
          />
        </h1>
        <p>
          <Trans
            i18nKey="top_description"
            components={{
              br: <br />,
              span: <span style={{ color: "#CAF881" }} />
            }}
          />
        </p>
        <div className="top-buttons">
          <button
            className="top-button buy-now"
            onClick={() => window.location.href = "#pricing"}
          >
            <FaShoppingCart />
            <span>{t('buy_now')}</span>
          </button>
          <button
            className="top-button reviews"
            onClick={() => window.open("https://discord.com/invite/zEeq3jTzAR", "_blank")}
          >
            <FaDiscord />
            <span>{t('join_discord')}</span>
          </button>
        </div>
      </div>
      <div className="top-right">
        <img src={previewImage} alt="EAGLE SCRIPT Rust No Recoil Script Interface Preview - Customizable Settings Dashboard" loading="lazy" />
      </div>
    </div>
  );
};

export default Top;
